module.exports = __webpack_public_path__ + "static/media/noavatar.3e607506.png";


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/UserBlock/components/UserAvatar/static/img/noavatar.png
// module id = 2777
// module chunks = 118